import { useQuery } from 'react-query'

import { CustomField } from '@webapp/core/entities/internal/CustomField'
import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'

interface UseQueryCustomFieldOptions {
  customFieldId: number
  enabled?: boolean
}

/**
 * A single custom field by id, for the field detail page. Works for both
 * line-item and header fields — the endpoint is level-agnostic.
 */
export const useQueryCustomField = ({
  customFieldId,
  enabled = true,
}: UseQueryCustomFieldOptions) => {
  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    ...customFieldQueryConfig.getCustomField(customFieldId),
    enabled,
    select: (constructorData) => new CustomField(constructorData),
  })

  return {
    customField: data ?? null,
    isFetching,
    isLoading: isLoading && !data,
    isError,
    error,
    refetch,
  }
}
